import React, { useEffect, useState } from "react";
import "../../Css/account.css";
import login from "../../Images/Login/login.gif";
import { LuUserRound } from "react-icons/lu";
import { Breadcrumb, Button, Checkbox, Form, Input, message } from "antd";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { setUserToken } from "../../features/authSlice";
import { setProfile, storeToken, setdeliveryaddress } from "../../services/localStorageServices";
import GoogleLogin from "react-google-login";
import { IoEyeOutline } from "react-icons/io5";
import { FaRegEyeSlash } from "react-icons/fa6";
import { post } from "../../services/userAuthAPI";
export default function SignIn() {

  ////// End Google Login ///////
  const { token } = useSelector((state) => state.auth);
  useEffect(() => {
    if (token) {
      navigate("/")
    }
  }, [token])

  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    console.log("login",values)
    setLoading(true);
    try {
      const payload = {
        login: values.username,
        password: values.password,
        user_type: 'user',
      };
  
      const response = await axios.post(
        "https://api.woodsy.co.in/api/login",
        payload,
        {
          headers: {
            "Content-Type": "application/json", // Set content-type to JSON
          },
        }
      );

      console.log("response",response)
  
      if (response) {
        dispatch(setUserToken({ token: response?.data?.data?.token }));
        storeToken(response?.data?.data?.token);
        setProfile(response?.data?.data);
        navigate("/");
      }
  
    } catch (error) {
      console.error("Login failed:", error);
      message.error(error?.response?.data?.message || "Login failed");
    } finally {
      setLoading(false);
    }
  };
  

  return (
    <div>
      <div className="Login-main-con">
        <div className="row">
          <div className="col-md-6 px-5">
            <div className="Login-page-Image-con">
              <img className="widthimage" src={login} alt="login"></img>
            </div>
          </div>
          <div className="col-md-6 px-5 d-flex align-items-center">
            <div className="account-card">
              <div className="title">
                <h1>Sign In</h1>
                <Breadcrumb
                  items={[
                    {
                      title: <Link to="/">Home</Link>,
                    },
                    {
                      title: "Sign In",
                    },
                  ]}
                />
              </div>
              <div className="account-form">
                <Form
                  name="normal_login"
                  className="login-form"
                  layout="vertical"
                  initialValues={{
                    remember: true,
                  }}
                  onFinish={onFinish}
                >
                  <Form.Item
                    name="username"
                    label="Email"
                    rules={[
                      {
                        required: true,
                        message: "Please input your email!",
                      },
                      {
                        type: "email",
                        message: "Please enter a valid email!",
                      },
                    ]}
                  >
                    <Input
                      prefix={<LuUserRound className="site-form-item-icon" />}
                      placeholder="Email"
                    />
                  </Form.Item>
                  <Form.Item
                    name="password"
                    label="Password"
                    rules={[
                      {
                        required: true,
                        message: "Please input your Password!",
                      },
                    ]}
                  >
                    <Input.Password
                      prefix={<LuUserRound className="site-form-item-icon" />}
                      placeholder="Password"
                      iconRender={visible => (visible ? <IoEyeOutline /> : <FaRegEyeSlash />)}
                    />
                  </Form.Item>
                  <Form.Item
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                    }}
                  >
                    <Form.Item name="remember" valuePropName="checked" noStyle>
                      <Checkbox>Remember me</Checkbox>
                    </Form.Item>

                    <Link className="login-form-forgot" to="/account/forgot-password">
                      Forgot password
                    </Link>
                  </Form.Item>

                  <Form.Item>
                    <Button
                      type="primary"
                      htmlType="submit"
                      className="login-form-button"
                      loading={loading}
                    >
                      Log in
                    </Button>
                    <br />
                    Or <Link to="/account/sign-up">register now!</Link>
                  </Form.Item>
                </Form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
